export const getFieldDescriptionType = <T extends { description?: string; htmlDescription?: string }>({
  description,
  htmlDescription,
}: T): "htmlDescription" | "description" | undefined => {
  if (htmlDescription) return "htmlDescription";
  if (description) return "description";
  return undefined;
};
